import React from "react"
import { twMerge } from "tailwind-merge"
import Button, { ButtonProps } from "./Button"

export interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: "green" | "purple"
}
export const primaryButtonStyles = `bg-purple text-white hover:bg-indigo-700 focus-visible:outline-indigo-600 transition-all duration-500 ease-out`
export const primaryButtonStylesDisabled = `disabled:opacity-50 disabled:cursor-not-allowed`

const PrimaryButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, ...props }, ref) => {
  return (
    <Button ref={ref} className={twMerge(primaryButtonStyles, primaryButtonStylesDisabled, className)} {...props} />
  )
})
PrimaryButton.displayName = "PrimaryButton"
export default PrimaryButton
